import Description from 'components/RecurringOrderSuggestionsDiscardReasonsModal/Sections/Description/styled';

export default Description;
